/* eslint-disable */
import Tab from "react-bootstrap/Tab";
import React, { useEffect, useState } from "react";
import {
  FaCheck,
  FaMapMarkerAlt,
  FaRegHeart,
  FaStar,
} from "react-icons/fa";
import { api_url } from "../../Constants/web_services";
import noimage from "../../Assets/images/Image_not_available.png";
import { Link } from "react-router-dom";
import Loading from "./Loading";
import NoSearchFound from "./NoSearchFound";
import Pagination from "./Pagination"

const SearchListContent = ({ contentView, formData }) => {
  const [showLoading, setShowLoading] = useState(true);
  const currentPage = useState(1);

  const itemsPerPage = formData?.data?.length;
  const itemsToDisplay = Array.isArray(formData?.data)
    ? formData?.data.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
    : [];
  const companies = formData?.data;

  // const totalResults = formData?.data.length;



  useEffect(() => {
    // Set a timer to switch from loading to data-checking state after 5 seconds
    const timer = setTimeout(() => {
      setShowLoading(false);
    }, 5000);

    // Clean up the timer
    return () => clearTimeout(timer);
  }, []);

  const renderNoDataView = () => {
    return formData?.data?.length === 0 ? <NoSearchFound /> : null;
  };





  return (
    <>
      <Tab.Container id="left-tabs-example" defaultActiveKey="first">
        <div className="aon-search-result-area">
          {/* <div className="sf-search-result-title" style={{ marginTop:"-120px", marginBottom:"30px" }}>
            <h5 className='text-022278 fw-bold s-18'>Showing {rangeStart} – {rangeEnd} of {totalResults} results</h5>
          </div> */}

          {/* Search Filter */}
          {/* <div className="sf-search-result-top flex-wrap d-flex justify-content-between align-items-center">
            <div className="sf-search-result-title">
              <h5 className='text-022278 fw-bold s-18'>Showing 1 – 10 of 16 results</h5>
            </div>
            <div className="sf-search-result-option d-flex justify-content-between align-items-center">
              <ul className="sf-search-sortby">
                <li className="sf-select-sort-by">
                  <Form.Select aria-label="Default select example" className="form-control sf-form-control" title="SORT BY" name="setorderby" id="setorderby">
                    <option className="bs-title-option text-muted" value="">SORT BY</option>
                    <option value="rating">Rating</option>
                    <option value="title">Title</option>
                    <option value="distance">Distance</option>
                  </Form.Select>
                </li>
                <li>
                  <Form.Select aria-label="Default select example" className="form-control sf-form-control" title="DESC" name="setorderby" id="setorder">
                    <option className="bs-title-option text-muted" value="">DESC</option>
                    <option value="rating">ASC</option>
                    <option value="title">DESC</option>
                  </Form.Select>
                </li>
                <li>
                  <Form.Select aria-label="Default select example" className="form-control sf-form-control" title={9} name="numberofpages" id="numberofpages">
                    <option className="bs-title-option text-muted" value="">9</option>
                    <option value={9}>9</option>
                    <option value={12}>12</option>
                    <option value={15}>15</option>
                    <option value={20}>20</option>
                    <option value={25}>25</option>
                    <option value={30}>30</option>
                  </Form.Select>
                </li>
              </ul>
              <ul className="sf-search-grid-option d-inline-flex" id="viewTypes">
                <Nav.Item data-view="grid-3">
                  <Nav.Link eventKey="first"><FaTh className='s-24' /></Nav.Link>
                </Nav.Item>
                <Nav.Item data-view="listview" className="ms-2">
                  <Nav.Link eventKey="second"><FaThList className='s-24' /></Nav.Link>
                </Nav.Item>
              </ul>
            </div>
          </div> */}
          {/* Search Filter End */}
          {/* <div className="sf-map-filter">
            <button className="search-filter-btn btn site-button" type="button">
              <FaSlidersH /> Search Filter
            </button>
          </div> */}
          <div className="page-content sidebar--display">
            {showLoading ? (
              <Loading />
            ) : formData?.data?.length > 0 ? (
              <div className="row">
                {contentView === "gridView"

                  ? companies.map((company, index) => (
                    <div className="col-xl-6" key={index}>
                      <div className="aon-vender-list-wrap3">
                        <div className="aon-vender-list-box3 d-flex align-items-center">
                          {company.logo ? (
                            <img
                              src={`${api_url}/${company.logo}`}
                              alt={`${company.name} Logo`}
                              className="aon-vender-pic-link"
                              style={{ maxWidth: "200px" }}
                            />
                          ) : (
                            <div
                              className="no-image-found text-danger"
                              style={{ width: "320px" }}
                            >
                              <img src={noimage} alt="" />
                            </div>
                          )}
                          <div className="aon-vender-list-info">
                            <h4 className="aon-venders-title">
                              <Link
                                to={`/company/${company.id}`}
                                className="text-decoration-none s-18 text-022279 fw-700 text-capitalize"
                              >
                                {company.name}
                              </Link>
                            </h4>
                            <span className="aon-venders-address s-16">
                              <FaMapMarkerAlt className="text-muted s-14 me-1" />
                              {company.office_location}
                            </span>
                            <div className="aon-ow-pro-rating">
                              <FaStar className="text-warning" />
                              <FaStar className="text-warning" />
                              <FaStar className="text-warning" />
                              <FaStar className="text-warning" />
                              <FaStar className="text-warning" />
                            </div>
                            <p>
                              {company.description.length > 50
                                ? `${company.description.substring(0, 50)}...`
                                : company.description}
                            </p>
                            <div className="aon-pro-check">
                              <span>
                                <FaCheck />
                              </span>
                            </div>
                            <div className="aon-pro-favorite">
                              <a href="/">
                                <FaRegHeart />
                              </a>
                            </div>
                            <div className="aon-req-btn">
                              <Link
                                className="aon-req-btn-posi text-decoration-none"
                                to={`/company/${company.id}`}
                              >
                                See Company Profile
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                  : companies.map((company, index) => (
                    <div className="col-md-12" key={index}>
                      <div className="aon-vender-list-wrap3">
                        <div className="aon-vender-list-box3 d-flex align-items-center">
                          {company.logo ? (
                            <img
                              src={`${api_url}/${company.logo}`}
                              alt={`${company.name} Logo`}
                              className="aon-vender-pic-link"
                              style={{ maxWidth: "200px" }}
                            />
                          ) : (
                            <div
                              className="no-image-found text-danger"
                              style={{ width: "320px" }}
                            >
                              <img src={noimage} alt="" />
                            </div>
                          )}
                          <div className="aon-vender-list-info">
                            <h4 className="aon-venders-title">
                              <Link
                                to={`/company/${company.id}`}
                                className="text-decoration-none s-18 text-022279 fw-700 text-capitalize"
                              >
                                {company.name}
                              </Link>
                            </h4>
                            <span className="aon-venders-address s-16">
                              <FaMapMarkerAlt className="text-muted s-14 me-1" />
                              {company.office_location}
                            </span>
                            <div className="aon-ow-pro-rating">
                              <FaStar className="text-warning" />
                              <FaStar className="text-warning" />
                              <FaStar className="text-warning" />
                              <FaStar className="text-warning" />
                              <FaStar className="text-warning" />
                            </div>
                            <p>
                              {company.description.length > 100
                                ? `${company.description.substring(0, 180)}...`
                                : company.description}
                            </p>
                            <div className="aon-pro-check">
                              <span>
                                <FaCheck />
                              </span>
                            </div>
                            <div className="aon-pro-favorite">
                              <a href="/">
                                <FaRegHeart />
                              </a>
                            </div>
                            <div className="aon-req-btn">
                              <Link
                                className="aon-req-btn-posi text-decoration-none"
                                to={`/company/${company.id}`}
                              >
                                See Company Profile
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            ) : (
              <NoSearchFound />
            )}
          </div>
          <Pagination formData={formData} />
        </div>
      </Tab.Container>
    </>
  );
};

export default SearchListContent;


// {/* Pagination */}
//  <div className="site-pagination mt-4 s-p-center">
//  <ul className="pagination">
//  <li className="page-item disabled">
//      <a className="page-link" href="/" tabIndex={-1}>
//      <FaChevronLeft />
//      </a>
//  </li>
//  <li className="page-item">
//      <a className="page-link" href="/">
//      1
//      </a>
//  </li>
//  <li className="page-item active">
//      <a className="page-link" href="/">
//      2 <span className="sr-only">(current)</span>
//      </a>
//  </li>
//  <li className="page-item">
//      <a className="page-link" href="/">
//      3
//      </a>
//  </li>
//  <li className="page-item">
//      <a className="page-link" href="/">
//      <FaEllipsisH />
//      </a>
//  </li>
//  <li className="page-item">
//      <a className="page-link" href="/">
//      11
//      </a>
//  </li>
//  <li className="page-item">
//      <a className="page-link" href="/">
//      <FaChevronRight />
//      </a>
//  </li>
//  </ul>
// </div>
